exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row.vertical-align{\n  height: 100%\n}\n\n.vertical-align {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n\n.vertical-align > [class^=\"col-\"],\n.vertical-align > [class*=\" col-\"] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;     /* Align the flex-items vertically */\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; /* Optional, to align inner flex-items\n                              horizontally within the column  */\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main